<template>
    <b-tabs id="tabsRsaGestioneCentroDiurnoList" ref="tabsRsaGestioneCentroDiurno" v-model="activeTabIndex" nav-wrapper-class="sa-tab-items" content-class="mt-3" class="sa-tab" style="height: 100%; padding-bottom: 25px" fill @input="onInputTabs">
        <b-tab id="tbRsaGestionePresenti" title="Programmati" active>
            <rsa-gestione-centro-diurno-programmati-component ref="cmpRsaGestioneCentroDiurnoProgrammatiComponent"></rsa-gestione-centro-diurno-programmati-component>
        </b-tab>
        <b-tab id="tbRsaGestioneProgrammati" title="Presenti">
            <rsa-gestione-centro-diurno-presenti-component ref="cmpRsaGestioneCentroDiurnoPresenti"></rsa-gestione-centro-diurno-presenti-component>
        </b-tab>
        <b-tab id="tbRsaGestioneAssenti" title="Assenti">
            <rsa-gestione-centro-diurno-assenti-component ref="cmpRsaGestioneCentroDiurnoAssentiComponent"></rsa-gestione-centro-diurno-assenti-component>
        </b-tab>
        <b-tab id="tbRsaGestioneAssenti" title="Rientrati a Domicilio">
            <rsa-gestione-centro-diurno-rientrati-domicilio-component></rsa-gestione-centro-diurno-rientrati-domicilio-component>
        </b-tab>
    </b-tabs>
</template>

<script>
import RsaGestioneCentroDiurnoAssentiComponent from "./RsaGestioneCentroDiurnoAssentiComponent.vue";
import RsaGestioneCentroDiurnoProgrammatiComponent from "./RsaGestioneCentroDiurnoProgrammatiComponent.vue";
import RsaGestioneCentroDiurnoPresentiComponent from "./RsaGestioneCentroDiurnoPresentiComponent.vue";
import RsaGestioneCentroDiurnoRientratiDomicilioComponent from "./RsaGestioneCentroDiurnoRientratiDomicilioComponent.vue";
export default {
    components: { RsaGestioneCentroDiurnoProgrammatiComponent, RsaGestioneCentroDiurnoPresentiComponent, RsaGestioneCentroDiurnoAssentiComponent, RsaGestioneCentroDiurnoRientratiDomicilioComponent },
    data() {
        return {
            activeTabIndex: 0,
            filtroGestioneCentroDiurno: null,
        };
    },
    methods: {
        init(filtroGestioneCentroDiurno) {
            this.filtroGestioneCentroDiurno = filtroGestioneCentroDiurno;
            this.tabSelection();
        },
        onInputTabs() {
            this.tabSelection();
        },
        tabSelection() {
            this.$emit("tabChange", this.activeTabIndex);
            switch (this.activeTabIndex) {
                case 0:
                    this.$refs.cmpRsaGestioneCentroDiurnoProgrammatiComponent.loadData(this.filtroGestioneCentroDiurno);
                    break;
                case 1:
                    this.$refs.cmpRsaGestioneCentroDiurnoPresenti.loadData(this.filtroGestioneCentroDiurno);
                    break;
                case 2:
                    this.$refs.cmpRsaGestioneCentroDiurnoAssentiComponent.loadData(this.filtroGestioneCentroDiurno);
                    break;
            }
        },
        salvaProgrammazione() {
            this.$refs.cmpRsaGestioneCentroDiurnoProgrammatiComponent.salvaProgrammazione();
        },
    },
};
</script>

<style></style>
